/* eslint-disable @typescript-eslint/no-shadow */
import { FC, useEffect, useRef, useState } from 'react';

type ItemSliderProps = {
  children: any;
  index?: number;
  itemWidth?: number;
  itemGap?: number;
};

const ItemSlider: FC<ItemSliderProps> = ({
  children,
  index = 0,
  itemWidth = 640,
  itemGap = 32,
}) => {
  const sliderWindow = useRef<HTMLDivElement>();
  const slide = useRef<HTMLDivElement>();
  const [size, setSize] = useState({ width: 800 });
  const [unit, setUnit] = useState(`${itemWidth}px`);

  useEffect(() => {
    function update() {
      if (sliderWindow.current) {
        const size = sliderWindow.current.getBoundingClientRect();
        setSize(size);
      }
    }

    update();
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('resize', update);
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth > 640) {
      setUnit(`${itemWidth}px`);
    } else {
      setUnit(`${size.width}px`);
    }
  }, [itemWidth]);

  if (!children && children.length === 0) return <></>;

  const rawPos = -(itemWidth * index);
  const rawWidth = itemWidth * children.length - itemGap;

  const position = rawPos; // Math.max(rawPos, -rawWidth + size.width);

  return (
    <>
      <div ref={sliderWindow} className="relative h-full">
        <div
          ref={slide}
          className={`grid relative transition-transform duration-1000 ease-in-out`}
          style={{
            gap: `${itemGap}px`,
            transform: `translate(${position}px)`,
            width: `${rawWidth}px`,
            gridTemplateColumns: `repeat(${children.length}, minmax(0, calc(${unit} - ${itemGap}px)))`,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
};

export default ItemSlider;
